// removed by extract-text-webpack-plugin
module.exports = {"container":"Home_container_EoH-a","container1":"Home_container1_2kAfv","logoContainer":"Home_logoContainer_2l1AZ","description":"Home_description_tZ6M7","solutions":"Home_solutions_3SGOE","lato-title":"Home_lato-title_11qI5 lato-title lato-title"};


//////////////////
// WEBPACK FOOTER
// ./src/static/home/Home.css
// module id = 446
// module chunks = 4